import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { NavLink } from "react-router-dom";
import PanelWrapper from "./layout/PanelWrapper";
import ServiceIcon from "./ServiceIcon";
import Lightbox from "react-image-lightbox";

class ServiceInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }
  render() {
    const { photoIndex, isOpen } = this.state;
    const images = [this.props.image1, this.props.image2, this.props.image3];
    return (
      <PanelWrapper>
        <Title>{this.props.title}</Title>
        <Wrapper>
          {this.props.tags.map((tag, index) => {
            return <ServiceIcon tag={tag} key={index} />;
          })}
        </Wrapper>
        <Wrapper>
          <Text>{this.props.description}</Text>
        </Wrapper>
        <ImageWrapper>
          <Image
            onClick={() => this.setState({ isOpen: true, photoIndex: 0 })}
            style={{ backgroundImage: "url(" + this.props.image1 + ")" }}
          />
          <Image
            onClick={() => this.setState({ isOpen: true, photoIndex: 1 })}
            style={{ backgroundImage: "url(" + this.props.image2 + ")" }}
          />
          <Image
            onClick={() => this.setState({ isOpen: true, photoIndex: 2 })}
            style={{ backgroundImage: "url(" + this.props.image3 + ")" }}
          />
        </ImageWrapper>

        <LinkContainer>
          <Link
            exact
            to="/gallery"
            onClick={() => this.toggleMobileMenuVisibility()}
          >
            View More Images
          </Link>
        </LinkContainer>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </PanelWrapper>
    );
  }
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Title = styled.h1`
  color: #ffc300;
  padding: 0;
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: normal;
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

const Link = styled(NavLink)`
  margin: 0;
  padding: 2px 10px;
  color: #000000;
  background: #ffc300;
  border: none;
  text-transform: uppercase;
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

const LinkContainer = styled.div`
  display: block;
  text-align: right;
  padding: 0;
  margin: 10px 0 0 0;
  border: none;
`;

const Wrapper = styled.div`
  padding: 0;
`;

const Text = styled.p`
  padding: 0;
  color: #ffffff;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 14px;
  margin: 10px 0 0 0;
  @media only screen and (max-width: 960px) {
    text-align: justify;
    font-size: 13px;
  }
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

const ImageWrapper = styled.div`
  padding: 0;
  display: flex;
  margin: 10px -2px -2px -2px;
`;

const Image = styled.div`
  flex: 1;
  height: 200px;
  margin: 2px;
  background-size: cover;
  @media only screen and (max-width: 960px) {
    height: 80px;
  }
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
  cursor: pointer;
`;

export default ServiceInfo;



// WEBPACK FOOTER //
// ./src/components/ServiceInfo.js